import { Id, toast, ToastOptions } from 'react-toastify';

export const Say = {
    success: (msg: string, id?: Id): Id =>
        toast.success(msg, { ...options, autoClose: 2000, toastId: id }),

    error: (msg: string, id?: Id): Id =>
        toast.error(msg, { ...options, autoClose: 7000, toastId: id }),

    info: (msg: string, id?: Id): Id =>
        toast.info(msg, { ...options, autoClose: 4000, toastId: id }),

    dismissAll: () => toast.dismiss()
}

const options: ToastOptions = {
    position: "top-center",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    //progress: undefined,
}



